"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HtmlText = _interopRequireDefault(require("../HtmlText"));
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = function _default(_ref) {
  let {
    markup,
    color,
    src,
    altText,
    className = ""
  } = _ref;
  const imgProps = {
    src,
    alt: altText,
    fill: color
  };
  if (!imgProps.alt) {
    imgProps.alt = "";
    imgProps.role = "presentation";
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: markup && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.IconContainer, {
      className: className,
      fill: color,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_HtmlText.default, {
        children: markup
      })
    }) || src && /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Image, {
      ...imgProps
    })
  });
};